import { render, staticRenderFns } from "./legacy_app.vue.js?vue&type=template&id=42bd9100!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./legacy_app.vue?vue&type=template&id=42bd9100"
import script from "./legacy_app.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./legacy_app.vue?vue&type=script&lang=js"
export * from "./legacy_app.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./legacy_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports